(() => {
  const destinations = [
    { label: 'Orders & Tracking', href: '/pages/order-tracking' },
    {
      label: 'Contact Support',
      href: 'https://wa.me/8613231006968?text=Hello%20Aucelia%2C%20I%27d%20like%20help%20with%20my%20order%20or%20bracelet.',
      external: true,
    },
    { label: 'Returns & Exchanges Policy', href: '/policies/refund-policy' },
  ];

  const desktopMenuSelector = [
    '#header-group header-menu details',
    '#header-group .header-menu__inner details',
    '#header-group .aucelia-owner-primary-nav details',
  ].join(',');

  const panelMatchesDestinations = (panel) => {
    const links = [...panel.querySelectorAll('a')];

    return (
      links.length === destinations.length &&
      links.every((link, index) => {
        const destination = destinations[index];
        return link.textContent.trim() === destination.label && link.getAttribute('href') === destination.href;
      })
    );
  };

  const syncCustomerServiceNavigation = () => {
    if (!window.matchMedia('(min-width: 750px)').matches) return;

    document.querySelectorAll(desktopMenuSelector).forEach((menu) => {
      const summary = menu.querySelector(':scope > summary');
      const panel = [...(menu?.children ?? [])].find((child) => child instanceof HTMLDivElement);

      if (!summary || !summary.textContent.toLowerCase().includes('customer service')) return;

      if (!panel || panelMatchesDestinations(panel)) return;

      const fragment = document.createDocumentFragment();
      destinations.forEach((destination) => {
        const link = document.createElement('a');
        link.href = destination.href;
        link.textContent = destination.label;

        if (destination.external) {
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
        }

        fragment.append(link);
      });

      panel.replaceChildren(fragment);
    });
  };

  let headerObserver;

  const startDesktopHeaderObserver = () => {
    if (!window.matchMedia('(min-width: 750px)').matches) return;

    const headerGroup = document.querySelector('#header-group');
    if (!headerGroup) return;

    syncCustomerServiceNavigation();

    if (headerObserver) return;
    headerObserver = new MutationObserver(syncCustomerServiceNavigation);
    headerObserver.observe(headerGroup, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startDesktopHeaderObserver, { once: true });
  } else {
    startDesktopHeaderObserver();
  }

  document.addEventListener('shopify:section:load', startDesktopHeaderObserver);
})();
